/**
 * Created by Florin David on 16/06/2017.
 */
import React, { ReactElement, useState } from 'react'
import { Button } from 'antd'
import { CloseOutlined } from '@ant-design/icons'

import styles from './index.module.scss'

import { setUpdateReady } from 'actions/app'

/**
 * Update ready - bar
 */
const UpdateReadyBar = (): ReactElement => {
  const [updating, setUpdating] = useState(false)

  const handleCloseClick = (): void => {
    setUpdateReady(false)
  }

  const handleOnUpdate = (): void => {
    setUpdating(false)
    setTimeout((): void => window.location.reload(), 100)
  }

  return (
    <div className={styles.updateReadyBar}>
      <div className={styles.title}>A new version is available</div>
      <div className={styles.controls}>
        <Button
          disabled={updating}
          type="primary"
          className={styles.update}
          onClick={handleOnUpdate}
        >
          Update
        </Button>
        <CloseOutlined className={styles.close} onClick={handleCloseClick} />
      </div>
    </div>
  )
}

export default UpdateReadyBar
